import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { credentials } from '../../credentials';

interface MapProps {
  lat: number;
  lng: number;
}

const Map: React.FC<MapProps> = ({ lat, lng }) => {
  const mapContainerStyle = {
    height: "90%",
    width: "90%"
  };

const center = { lat, lng };

  return (
    <LoadScript
      googleMapsApiKey={credentials}
    >
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={18}
      >
        <Marker position={center} />
      </GoogleMap>
    </LoadScript>
  );
};

export default Map;



